import React from "react";
import { motion } from "framer-motion";

// Icons

import { ArrowDown, ChevronDown } from "react-feather";

const Chevron = (props) => {
  const ChevronVariant = {
    inactive: {
      paddingTop: "0%",
      rotate: "0deg",
      transition: {
        ease: [0.6, 0.01, -0.05, 0.95],
        duration: 0.6,
        delay: 0,
      },
    },
    active: {
      paddingTop: "1%",
      rotate: "180deg",
      transition: {
        ease: [0.6, 0.01, -0.05, 0.95],
        duration: 0.6,
        delay: 0,
      },
    },
  };
  return (
    <>
      <motion.div
        variants={ChevronVariant}
        initial="inactive"
        animate={props.active ? "active" : "inactive"}
      >
        <ChevronDown
          className={"props.className"}
          height={props.height}
          width={props.width}
        />
      </motion.div>
    </>
  );
};

export default Chevron;
